import Parameters from "../components/Parameters/Parameters.vue";

let routes = {
    path: "/parameters",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/parameters",
            name: "Parâmetros",
            component: Parameters
        },
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/parameters.js